// This includes all products destined for the "HealthInsuranceNew" folder.
const isNewProduct = (acuvisorProductId) => {
  // Add all new product ids here
  const productIds = [31072023];
  return productIds.includes(acuvisorProductId);
};

export default isNewProduct;
